import { Alert, Button, Card, Checkbox, Form, Input, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AccountBean, AdvertiserBean, MediaAgencyBean, TimeZoneBean } from 'src/api/api'
import { enumView } from 'src/util/Util'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'
import accountApi from './AccountApi'

const FormItem = Form.Item
const Option = Select.Option
const roleEnum = AccountBean.RoleEnum

import AccountRoleEnum = AccountBean.RoleEnum

interface Props { }

const formInfoItems: FormDataType[] = [
    FormDataType.TimeZones,
    FormDataType.MediaAgencies,
    FormDataType.Advertisers
]

const AccountCreate: React.FC<Props> = () => {

    const [info, setInfo] = useState({
        timezones: [],
        mediaAgencies: [],
        advertisers: []
    })

    const [form] = useForm()
    const [error, setError] = useState()
    const navigateTo = useNavigate()

    const loadFormData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadFormData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await accountApi.create(values)
            navigateTo('/account')
        } catch (e) {
            setError(e.error)
        }
    }

    const role = Form.useWatch('role', form)

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
    >
        {error ? <Alert message={error} type="error" /> : null}
        <Card size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input />
            </FormItem>
            <FormItem
                required
                name="email"
                label="Email"
            >
                <Input />
            </FormItem>
            <FormItem
                required
                name="role"
                label="Role"
            >
                <Select
                    placeholder="Select Role">
                    {Object.values(AccountRoleEnum).map(item => <Option key={item} value={item}>{enumView(item)}</Option>)}
                </Select>
            </FormItem>
            {role == roleEnum.AgencyAdmin && <FormItem
                name="managed"
                label="Media Agencies"
            >
                <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    placeholder="Select Media Agencies">
                    {info.mediaAgencies.map((item: MediaAgencyBean) => <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </FormItem>}
            {role == roleEnum.AgencyManager && <FormItem
                name="managed"
                label="Advertisers"
            >
                <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    placeholder="Select Advertisers">
                    {info.advertisers.map((item: AdvertiserBean) => <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </FormItem>}
            <FormItem
                name="timezone"
                label="Time Zone"
            >
                <Select
                    showSearch
                    placeholder="Select time zone">
                    {info.timezones.map((timezone: TimeZoneBean) =>
                        <Option key={timezone.id} value={timezone.id as string}>{timezone.id}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="password"
                label="Password"
            >
                <Input type="password" />
            </FormItem>
            <FormItem
                required
                name="passwordConfirm"
                label="Password Confirm"
            >
                <Input type="password" />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
                required
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/account')}>Cancel</Button>
        </div>
    </Form>
}

export default AccountCreate


// WEBPACK FOOTER //
// ./src/component/app/account/AccountCreate.tsx